import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import Translate from '../Translate';
import PriceFormatter from '../formatterComponents/PriceFormatter';
import BookingOverviewServiceContainer from '../../containers/BookingOverviewServiceContainer';
import BookingOverviewOwnServiceContainer from '../../containers/BookingOverviewOwnServiceContainer';
import {prepaidVoucherExist} from "../../api/utils";

const BookingOverviewLineItems = ({calculatedFee, order, rental, totalPriceWithCardFee}) => {
  const isTherePrepaidVoucher = prepaidVoucherExist(order.bookingPrice.prepaidVoucher);
  const isPrepaidVoucherFullCover = isTherePrepaidVoucher && order.bookingPrice.prepaidVoucher.amount >= order.bookingPrice.paymentBeforeArrival.amount;
  if (order.adults <= 0) {
    return null;
  }

  return (
    <div>
      <BookingOverviewServiceContainer
        className="spread-list"
        order={order}
        subtotalClassName="booking-overview__subtotal"
      />

      <BookingOverviewOwnServiceContainer
        className="spread-list"
        order={order}
        rental={rental}
        subtotalClassName="booking-overview__subtotal"
      />

      <section className="booking-overview__section">
        <ul className="spread-list">
          {calculatedFee && (
            <li className="booking-overview__card-fee">
              <div>
                <Translate content="Card fee" />
              </div>
              <div>
                <PriceFormatter price={calculatedFee} />
              </div>
            </li>
          )}
          <li className="booking-overview__total">
            <Translate component="div" content="Total price" />
            <div>
              <PriceFormatter price={totalPriceWithCardFee}/>
            </div>
          </li>
          {isTherePrepaidVoucher ? (
            <>
              <li className="booking-overview__prepaidVoucher">
                <Translate component="div" content="Voucher code"/>
                <div>
                  <PriceFormatter prefix="- " price={order.bookingPrice.prepaidVoucher}/>
                </div>
              </li>
              {isPrepaidVoucherFullCover ?
                <Translate component="div" className="booking-overview__prepaidVoucher-info"
                           args={{'!amount': `${order.bookingPrice.prepaidVoucherRemainder.amount} ${order.bookingPrice.prepaidVoucherRemainder.currencyCode}`}}
                           content="The remaining !amount will be refunded after your payment has been processed on your new booking."/>
                :
                <Translate component="div" className="booking-overview__prepaidVoucher-info"
                           content="Your voucher code does not cover the full amount. You can book now and will be able to pay the remaining amount in your MyBooking after completing your booking."/>}

            </>
          ) : <></>}
        </ul>
      </section>
    </div>
  );
};

BookingOverviewLineItems.PropTypes = {
  calculatedFee:PropTypes.shape({
    amount:PropTypes.number.isRequired,
    currencyCode:PropTypes.string.isRequired,
  }),
  order:PropTypes.shape({
    bookingPrice:PropTypes.shape({
      prepaidVoucher: PropTypes.object,
    }).isRequired,
    adults:PropTypes.number.isRequired,
  }).isRequired,
  rental:PropTypes.object.isRequired,
  totalPriceWithCardFee:PropTypes.shape({
    amount:PropTypes.number.isRequired,
    currencyCode:PropTypes.string.isRequired,
  }).isRequired,
};

export default BookingOverviewLineItems;
